import React from 'react';
import { Typography } from 'fronton-react';
import { styled } from 'linaria/react';
import { WarningIcon } from '@fronton/icons-react';

export const WarningSnackBar = () => (
  <WarningBarContainer>
    <ParagraphContainer>
      <WarningIcon type="outline" size="l" color="text-primary" />
      <Typography size="body_long" variant="s">
        Введите такие параметры помещения, чтобы их произведение было больше 1,4 м²
      </Typography>
    </ParagraphContainer>
  </WarningBarContainer>
);

const WarningBarContainer = styled.div`
  display: flex;
  padding: 16px;
  margin-top: var(--space-350);
  background: var(--attention-light);
  border-radius: var(--rounding-l);
`;

const ParagraphContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px !important;
  }
`;
